// The write half of upstream's `FileDownload.saveFile`. The fetch half is in
// `packages/api/src/reports.ts`, so the request shape stays testable without a DOM.
import type { DownloadedFile } from '@woo-ext/api'

/**
 * Upstream uses `file-saver`'s `saveAs`. An anchor with `download` is the same thing without
 * the dependency: every browser this extension supports honours it, and `file-saver` itself
 * falls back to exactly this.
 *
 * ⚠️ REVOKE THE OBJECT URL. The blob is held alive by the URL, not by the anchor, so a page
 * that exports repeatedly without this leaks the whole CSV each time. It cannot be revoked
 * synchronously after `click()` in every browser, hence the task boundary.
 */
export function saveFile(file: DownloadedFile): void {
  const url = URL.createObjectURL(file.blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = file.filename
  anchor.rel = 'noopener'
  // Not appended to the document: a detached anchor's click still downloads, and appending
  // one to <body> inside a 200px iframe has been known to shift layout for a frame.
  anchor.click()
  setTimeout(() => {
    URL.revokeObjectURL(url)
  }, 0)
}
